import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import * as organizationApi from '@/features/organization/api';
import type { CreateOrganizationInput, OrganizationView } from '@/features/organization/types';
import type { ApiError } from '@/lib/api/client';

/**
 * Platform-scoped (G-9, Job 6) - deliberately does not read or invalidate
 * any tenant-scoped query key, mirroring `useInviteOrganizationAdmin`'s own
 * reasoning: the caller (a Platform Super Admin) holds no Active
 * Organization of their own to key one by.
 */
export function useCreateOrganization(): UseMutationResult<
  OrganizationView,
  ApiError,
  CreateOrganizationInput
> {
  return useMutation({
    mutationFn: (input: CreateOrganizationInput) => organizationApi.createOrganization(input),
  });
}
